/**
 * GuitarFinds — Brand Logo Marquee
 * Keeps motion preferences and Theme Editor lifecycle clean.
 */
(function () {
  'use strict';

  class BrandMarquee {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.gf-marquee__track');
      this.abortController = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onReducedMotionChange = () => this.applyMotionPreference();

      if (!this.track) return;
      this._ensureDuplicateGroup();

      this.reducedMotion.addEventListener('change', this.onReducedMotionChange, {
        signal: this.abortController.signal
      });

      this.el.addEventListener('focusin', () => this.el.classList.add('is-paused'), {
        signal: this.abortController.signal
      });

      this.el.addEventListener('focusout', () => this.applyMotionPreference(), {
        signal: this.abortController.signal
      });

      this.applyMotionPreference();
    }

    _ensureDuplicateGroup() {
      if (this.track.querySelector('[data-duplicate-group]')) return;

      const source = this.track.querySelector('.gf-marquee__group');
      if (!source) return;

      const duplicate = source.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.setAttribute('data-duplicate-group', '');
      duplicate.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      duplicate.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
        node.removeAttribute('data-shopify-editor-block');
      });
      duplicate.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((node) => {
        node.setAttribute('tabindex', '-1');
      });
      this.track.appendChild(duplicate);
    }

    applyMotionPreference() {
      this.el.classList.toggle('is-paused', this.reducedMotion.matches);
    }

    destroy() {
      this.abortController.abort();
      this.reducedMotion.removeEventListener('change', this.onReducedMotionChange);
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-brand-marquee]').forEach((el) => {
      if (!el._brandMarquee) el._brandMarquee = new BrandMarquee(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    const el = event.target.querySelector('[data-brand-marquee]');
    if (!el?._brandMarquee) return;
    el._brandMarquee.destroy();
    delete el._brandMarquee;
  });
})();
